import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { ISchedule } from '../../../types/schedule'
import { getUrlWithVersion } from '../../../api/api'

export const fetchProductJobSchedule = createAsyncThunk<
    { guid: string; data: ISchedule[] },
    { productId: string },
    ThunkConfig<string>
>('schedulesSlice/fetchProductJobSchedule', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const productId = args.productId

    try {
        const { data } = await api.get<Array<ISchedule>>(
            getUrlWithVersion(
                `/products/${productId}/core_settings/job_schedule`
            )
        )

        return { guid: productId, data }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to fetch product job schedule')
    }
})
